import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import { handleShareClick } from '@/methods/handleShareClick'

// Components
import Icon from '@/assets/icons'

// Constants

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface ShareProps {
  className: string
  socket: any
}

const Share = (props: ShareProps) => {
  const { className, socket } = props

  const { t } = useTranslation()

  return (
    <div className={cx('share', className)} onClick={() => handleShareClick({ socket })}>
      <p className={cx('share-text')}>{t('Common_Share_Friend')}</p>
      <div className={cx('share-icon')}>
        <Icon.Share />
      </div>
    </div>
  )
}

export default Share
